import { useGlobalState } from 'Data/context/GlobalState';
import { useStateWithRef } from 'Lib/hooks/useStateWithRef';
import { useEffect, useState } from 'react';

export const usePersistentPaging = (pagingDataKey, defaultSort) => {
  const [globalState, updateGlobalState] = useGlobalState();
  const [_, setPaging, pagingRef] = useStateWithRef(globalState[pagingDataKey]);
  const [initialPaging, setInitialPaging] = useState({});

  useEffect(() => {
    let cachedPaging = globalState[pagingDataKey] || {};
    if (defaultSort && !cachedPaging?.sort) {
      cachedPaging.sort = defaultSort;
    }
    setPaging(cachedPaging);
    setInitialPaging(cachedPaging);
    return () => {
      updateGlobalState(pagingDataKey, pagingRef.current);
    };
  }, []);

  return [initialPaging, setPaging];
};
